import React, { useId } from "react";
import classNames from "classnames";

import { selectAllText } from "@utils/selectAllText";

import "./SeedDisplay.scss";

interface SeedDisplayProps {
  seed: string;
  fullWidth?: boolean;
  className?: string;
}

const SeedDisplay = ({ seed, fullWidth, className }: SeedDisplayProps) => {
  const containerId = useId();
  const words = seed.trim().split(/\s+/);

  const handleSelectText = () => selectAllText(containerId);

  const handleCopy = (event: React.ClipboardEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.clipboardData.setData("text/plain", seed.trim());
  };

  const classes = classNames("seed-display", { "full-width": fullWidth }, className);

  return (
    <div id={containerId} className={classes} onClick={handleSelectText} onCopy={handleCopy}>
      {words.map((word, index) => (
        <span key={`${word}-${index}`} className="p0">
          {word}
          {index < words.length - 1 ? " " : ""}
        </span>
      ))}
    </div>
  );
};

export default SeedDisplay;
